 <div class="help-modal">
  <div class="help-modal__header">
    <button class="common-button__icon-xs-noborder"
        (click)="handleDismiss()">
        <i class="lf-icon-close-thick common-icon__sm"></i>
    </button>
  </div>
  <div class="help-modal__container">
    <div class="help-modal__box">
      <div class="help-modal__box-header">
        <span class="help-modal__title-box"
          [afTranslate]="'modal-help.contact-us'">_Contáctanos</span>
      </div>
      <div class="help-modal__sub-box gap-8">
        <div class="help-modal__sub-box-item">
          <i class="lf-icon-mail common-icon__xl common-icon__main"></i>
          <span class="help-modal__sub-box-title" [afSiteTerms]="'mail'">_clientes&#64;lefebvre.es</span>
        </div>
        <div class="help-modal__sub-box-item">
          <i class="lf-icon-call common-icon__xl common-icon__main"></i>
          <span class="help-modal__sub-box-title" [afSiteTerms]="'tel'">_91 210 80 00 - 902 44 33 55</span>
          @if(skin === "dark-blue" || skin === "icam-red"){
            <span class="help-modal__sub-box-text" [afTranslate]="'modal-help.info-hours'">_Lunes a viernes: 8:30 a 19:00 h</span>
          }@else if(skin === "steel-blue"){
            <div class="help-modal__container-sub-box">
              <span class="help-modal__sub-box-text" [afTranslate]="'modal-help.contact-assistance-info-be-1'"></span>
              <span class="help-modal__sub-box-text" [afTranslate]="'modal-help.contact-assistance-info-be-2'"></span>
            </div>
          }@else if(skin === "uk-steel-blue"){
            <div class="help-modal__container-sub-box">
              <span class="help-modal__sub-box-text" [afTranslate]="'modal-help.info-uk-general-assistance'"></span>
              <span class="help-modal__sub-box-text" [afTranslate]="'modal-help.info-uk-technical-support'"></span>
            </div>
          }@else if(skin === "gm-law"){
            <span class="help-modal__sub-box-text" [afTranslate]="'modal-help.info'"></span>
          }
        </div>
      </div>
    </div>
    @if (skin === "dark-blue") {
      <div class="help-modal__box">
        <div class="help-modal__box-header">
          <span class="help-modal__title-box" [afTranslate]="'modal-help.chat-assist'">_Chat online</span>
        </div>
        <div class="help-modal__sub-box gap-3">
          <div class="help-modal__sub-box-item">
            <i class="lf-icon-chat common-icon__xxl common-icon__main"></i>
            <span class="help-modal__sub-box-text-principal"
              [afTranslate]="'modal-help.contact-support-info'">_Contacta con nuestro equipo de soporte para tener respuesta inmediata a tus  preguntas.</span>
            <div class="help-modal__container-sub-box">
              <span class="help-modal__sub-box-text"
                [afTranslate]="'modal-help.info-chat-l-j'">
                _Lunes a jueves: 8:30-18:00 h
              </span>
              <span class="help-modal__sub-box-text"
                [afTranslate]="'modal-help.info-chat-v'">
                _Viernes: 8:30-14:30 h
              </span>
            </div>
          </div>
          <button class="common-button__text-noborder"
            (click)="initChat()">
            <span class="common-button__text-title"
              [afTranslate]="'modal-help.start-chat'">_Iniciar chat</span>
          </button>
        </div>
      </div>
    }
    <div class="help-modal__box-secondary">
      <div class="help-modal__box-seconday_header">
        <span class="help-modal__title-box" [afTranslate]="'modal-help.help-center'">_Centro de ayuda</span>
      </div>
      <div class="help-modal__common-sub-box">
        @if(skin !== "gm-law") {
          <button class="help-modal__common-button" (click)="openURL(1)">
            <span class="help-modal__sub-box-title" [afTranslate]="'modal-help.faq'">_Preguntas frecuentes</span>
          </button>
        }
        @if(skin === "dark-blue" || skin === "icam-red") {
          <button class="help-modal__common-button" (click)="openURL(3)">
            <span class="help-modal__sub-box-title" [afTranslate]="'modal-help.video'">_Videos</span>
          </button>
        }
        <button class="help-modal__common-button" (click)="openURL(4)">
          <span class="help-modal__sub-box-title" [afTranslate]="'modal-help.manual'">_Manuales</span>
        </button>
        @if(skin === "dark-blue" || skin === "icam-red") {
          <button class="help-modal__common-button" (click)="openURL(2)">
            <span class="help-modal__sub-box-title" [afTranslate]="'modal-help.curso'">_Cursos</span>
          </button>
        }
      </div>
    </div>
  </div>
 </div>
